var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-item",on:{"click":_vm.click}},[_vm._t("left",function(){return [_c('span',[_vm._v(_vm._s(_vm.title))])]}),_c('div',{staticClass:"center-item-right"},[_vm._t("right",function(){return [_c('img',{staticClass:"right",attrs:{"src":require("../assets/images/right.svg"),"alt":""}})]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }